import { Button, DatePicker, Form, Input, Select } from 'antd'
import { debounce } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { BOOKING_STATUS, BOOKING_TYPE } from './configs'

const { Option } = Select
const { RangePicker } = DatePicker

const FilterForm = ({ handleSearch, setFilters }) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
    form.resetFields()
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      onValuesChange={(_, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 16,
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <Form.Item label="Người lên book" name="user_create">
            <Input
              placeholder="Nhập ID người lên book"
              onBlur={(e) => {
                form.setFieldsValue({ user_create: e.target.value?.trim() })
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <Form.Item label="Mã tin" name="post_id">
            <Input
              placeholder="Nhập mã bài viết"
              onBlur={(e) => {
                form.setFieldsValue({ post_id: e.target.value?.trim() })
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <Form.Item label="Người book" name="booker_id">
            <Input
              placeholder="Nhập ID người book"
              onBlur={(e) => {
                form.setFieldsValue({ booker_id: e.target.value?.trim() })
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <Form.Item label="Loại book" name="type">
            <Select placeholder="Chọn loại book" allowClear>
              {BOOKING_TYPE.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <Form.Item label="Hiện trạng" name="status">
            <Select placeholder="Chọn hiện trạng" allowClear>
              {BOOKING_STATUS.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 260px', minWidth: 260 }}>
          <Form.Item
            label="Từ ngày - Đến ngày"
            name="date"
            rules={[
              {
                validator: (_, value) => {
                  if (!value?.[0] || !value?.[1]) {
                    return Promise.resolve()
                  }
                  if (value[1].diff(value[0], 'day') > 60) {
                    return Promise.reject(
                      new Error('Khoảng thời gian không được vượt quá 60 ngày')
                    )
                  }
                  return Promise.resolve()
                }
              }
            ]}
          >
            <RangePicker
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
              disabledDate={(current, info) => {
                const from = info?.from
                if (!from || !current) return false
                return Math.abs(current.diff(from, 'day')) > 60
              }}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end',
            flex: '1 1 220px',
            minWidth: 220
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit">
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default FilterForm
